import Modal from "../ui/Modal";
import Button from "../ui/Button";
import CardFace from "./CardFace";
import { useLanguage } from "../../i18n/LanguageContext";
import type { AnyCard } from "../../types/cards";

interface Props { card: AnyCard | null; open: boolean; onConfirm: () => void; }

export default function CardDetailModal({ card, open, onConfirm }: Props) {
  const { t } = useLanguage();
  if (!card) return null;
  const tCard =
    card.deck === "event"       ? (t.events?.[card.id]      ?? null) :
    card.deck === "earnings"    ? (t.earnings?.[card.id]    ?? null) :
    card.deck === "preparation" ? (t.preparation?.[card.id] ?? null) : null;
  const explanation = tCard?.conceptExplanation ?? card.conceptExplanation;
  return (
    <Modal open={open} wide>
      <div className="p-6 flex flex-col gap-5">
        <div className="w-full"><CardFace card={card} /></div>
        <div className="bg-white/5 rounded-xl p-4 border border-white/10">
          <div className="text-xs font-bold tracking-widest text-white/40 mb-2">{t.modal.financeTip}</div>
          <p className="text-white/90 leading-relaxed font-display">{explanation}</p>
        </div>
        <Button onClick={onConfirm} size="lg" className="w-full">{t.modal.gotIt}</Button>
      </div>
    </Modal>
  );
}
